import {useMutation} from '@apollo/react-hooks';

import type {
    RequestImport2Sponsorship as RequestImport2SponsorshipMutation,
    RequestImport2SponsorshipVariables as RequestImport2SponsorshipMutationVariables,
} from 'nutshell-graphql-types';

import REQUEST_SPONSORSHIP from '../mutations/request-import2-sponsorship.graphql';

export function useRequestImport2Sponsorship(): (originId: string) => Promise<any> {
    const [requestSponsorship] = useMutation<
        RequestImport2SponsorshipMutation,
        RequestImport2SponsorshipMutationVariables
    >(REQUEST_SPONSORSHIP);

    return (originId: string) => {
        return requestSponsorship({
            variables: {input: {originId}},
        });
    };
}
